module.exports = __webpack_public_path__ + "e0639ac9c5476eeb6a437205167e9094.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/nadine-selfie.jpg
 ** module id = 386
 ** module chunks = 0
 **/